import gql from "graphql-tag";

export const PROJECTS_QUERY = gql`
  query Projects(
    $name: String
    $officeIds: [SmartID]
    $showArchived: Boolean
    $showSlapshotRequested: Boolean
    $showCompleted: Boolean
    $projectType: String
    $startDate: DateTime
    $createdBy: SmartID
    $limit: Int
    $endCursor: String
  ) {
    projects(
      name: $name
      first: $limit
      after: $endCursor
      officeIds: $officeIds
      showArchived: $showArchived
      showSlapshotRequested: $showSlapshotRequested
      showCompleted: $showCompleted
      projectType: $projectType
      startDate: $startDate
      createdBy: $createdBy
    ) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          id
          isArchived
          projectCategory {
            id
            type
          }
          creator {
            id
            firstName
            lastName
            office {
              id
              name
              company {
                profile {
                  ... on ClientProfile {
                    companyName
                  }
                  ... on VendorProfile {
                    companyName
                  }
                }
              }
            }
          }
          name
          userNotificationSubscriptions
          subscribedUsers {
            id
            firstName
            lastName
            lastLogin
            profilePictureUrl
          }
          tasks {
            edges {
              node {
                service {
                  name
                }
              }
            }
          }
          progress
          projectShotCount
          thumbnailUrls
          startDate
          endDate
          serviceNames
          securityLevel
          hasCompletedTasks
        }
      }
    }
  }
`;

export const PROJECT_FILTER_QUERY = gql`
  query ProjectFilters {
    projectOffices {
      id
      name
    }

    projectCategory {
      id
      name
      type
    }

    projectCreators {
      id
      email
      fullName
    }
  }
`;
